export default __webpack_public_path__ + "fcd5eb31a31640378883fc4a1549e3b1.PNG";